import React, { ReactNode } from "react";
import InternalContainer from "./InternalContainer";

type CardProps = {
    className?: string;
    title?: string;
    subtitle?: string;
    children?: ReactNode;
    header?: ReactNode;
    footer?: ReactNode;
};

const Card = (props: CardProps) => {
    const { className = "" } = props;

    return (
        <div
            className={`flex flex-col items-stretch bg-white shadow-sm sm:rounded-lg ${className}`}
        >
            {props.header && (
                <div className="bg-gray-50 py-3 text-right sm:rounded-t-lg">
                    <InternalContainer>{props.header}</InternalContainer>
                </div>
            )}
            <div className="w-full grow py-6">
                <InternalContainer>
                    <div className="space-y-4">
                        {(props.title || props.subtitle) && (
                            <div>
                                {props.title && (
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                                        {props.title}
                                    </h3>
                                )}
                                {props.subtitle && (
                                    <p className="mt-1 text-sm text-gray-500">
                                        {props.subtitle}
                                    </p>
                                )}
                            </div>
                        )}

                        {props.children}
                    </div>
                </InternalContainer>
            </div>
            {props.footer && (
                <div className="w-full self-end bg-gray-50 py-3 text-right sm:rounded-b-lg">
                    <InternalContainer>{props.footer}</InternalContainer>
                </div>
            )}
        </div>
    );
};

export default Card;
